import React from 'react';
import { Typography } from '@mui/material';

const MyAccountDashboardPage: React.FC = () => {
  return (
    <div>
      <Typography variant="h3">My Account Dashboard Page</Typography>
      <Typography>This is a demo About page using Material UI.</Typography>
    </div>
  );
};

export default MyAccountDashboardPage;
